import { useSmsSettingsViewQuery } from 'core/graphql';

import { useSmsPermissions } from './useSmsPermissions';

export interface ISmsShortener {
  /** Ответ пришёл: пока `false`, форма не обещает и не пугает. */
  known: boolean;
  /** Сократитель настроен (`SHORTLINK_BASE_URL`). */
  enabled: boolean;
}

/**
 * Перепроверка 0084 — настроен ли сократитель, для форм отправки SMS.
 *
 * Ссылки в SMS уходят ТОЛЬКО короткими: без сократителя сервер откажет
 * `SHORTLINK_DISABLED`. Форма не обещает «станет короткой», а заранее
 * предупреждает. Сигнал — тот же, что у «SMS → Настройки»
 * (`smsSettings.shortlinkBaseUrl`); его читают все роли раздела SMS, и
 * запрос не шлётся с чужой роли.
 */
export const useSmsShortener = (): ISmsShortener => {
  const { canUse } = useSmsPermissions();
  const { data } = useSmsSettingsViewQuery({
    skip: !canUse,
    fetchPolicy: 'cache-first',
  });
  const settings = data?.smsSettings;
  return {
    known: Boolean(settings),
    enabled: Boolean(settings?.shortlinkBaseUrl),
  };
};
